import { render, staticRenderFns } from "./userExamPreview.vue?vue&type=template&id=882549b4&scoped=true&"
import script from "./userExamPreview.vue?vue&type=script&lang=js&"
export * from "./userExamPreview.vue?vue&type=script&lang=js&"
import style0 from "./userExamPreview.vue?vue&type=style&index=0&id=882549b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "882549b4",
  null
  
)

export default component.exports